import Link from 'next/link';

import {Chevron} from '@ui-kit/src/assets/Icons/Chevron';

import styles from './SelectionHead.module.scss';

type Props = {
  isLinkShown?: boolean;
  title: string;
  link?: {
    title: string;
    href: string;
  };
};

export const SelectionHead = ({isLinkShown = true, title, link}: Props) => {
  return (
    <div className={styles.head}>
      <h2 className={styles.title}>{title}</h2>
      {isLinkShown && link && (
        <Link href={link?.href} className={styles.link}>
          {link?.title}
          <Chevron className={styles.icon} />
        </Link>
      )}
    </div>
  );
};
